// examples/Items/NotificationItem/index.js (Modified)

import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import Icon from '@mui/material/Icon'; // Keep for date icon
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
// Assuming menuItem style is still needed for the overall MenuItem
import { menuItem } from 'examples/Items/NotificationItem/styles'; // Remove menuImage import if not used elsewhere

const NotificationItem = forwardRef(({ image, title, date, ...rest }, ref) => (
  // Removed color prop from arguments
  <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
    {/* Container for the icon - remove background/fixed size */}
    <ArgonBox
      // Remove props related to background/fixed size:
      // width="2.25rem"
      // height="2.25rem"
      // borderRadius="lg"
      // sx={(theme) => menuImage(theme)} // Remove sx call applying background style
      // Add styling directly or ensure parent handles alignment
      display="flex" // Use flex to center icon vertically if needed
      alignItems="center"
      mt={0.25}
      mr={1.5} // Adjust margin as needed
      mb={0.25}
    >
      {/* The 'image' prop now contains the <Icon> with its color set */}
      {image}
    </ArgonBox>
    {/* Container for the text content */}
    <ArgonBox>
      {/* Use smaller variant like 'caption' and adjust font weight/size */}
      <ArgonTypography variant="caption" textTransform="capitalize" fontWeight="regular">
        <strong>{title[0]}</strong> {title[1]}
      </ArgonTypography>
      {/* Date/Time row */}
      <ArgonTypography
        variant="caption" // Use caption
        fontSize="0.75rem" // Explicitly smaller font size
        color="secondary"
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 0.5, // Adjust spacing if needed
        }}
      >
        {/* Date icon */}
        <Icon
          sx={{
            lineHeight: 1, // Adjust line height
            mr: 0.5,
            fontSize: '0.875rem', // Make date icon slightly smaller
          }}
          color="secondary" // Keep date icon color consistent
        >
          watch_later
        </Icon>
        {/* Date text */}
        {date}
      </ArgonTypography>
    </ArgonBox>
  </MenuItem>
));

// Remove color prop from defaultProps and propTypes
NotificationItem.defaultProps = {
  // No default props needed here anymore unless others are added
};

NotificationItem.propTypes = {
  // color prop removed
  image: PropTypes.node.isRequired,
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  date: PropTypes.string.isRequired,
};

export default NotificationItem;
